import { Directive, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ElementRef, ViewContainerRef, ComponentFactoryResolver, ReflectiveInjector } from '@angular/core';

import { Font } from './interfaces';

import { FontPickerComponent } from './font-picker.component';


export class FontPickerDirective implements OnInit {
  private dialog: any;

   fontPicker: Font;

   fpWidth: string = '280px';
   fpHeight: string = '320px';

   fpFallbackFont: Font = new Font({
    family: 'Roboto',
    size: '16px',
    style: 'regular',
    styles: ['regular']
  });

   fpPresetLabel: string;
   fpPresetFonts: Array<string>;

   fpSizeSelect: boolean = true;
   fpStyleSelect: boolean = true;

   fpPosition: string = 'bottom';
   fpPositionOffset: string = '0%';
   fpPositionRelativeToArrow: boolean = false;

   fpCancelButton: boolean = false;
   fpCancelButtonText: string = 'Cancel';
   fpCancelButtonClass: string = 'fp-cancel-button-class';

   fpUploadButton: boolean = false;
   fpUploadButtonText: string = 'Upload';
   fpUploadButtonClass: string = 'fp-upload-button-class';

   fontPickerChange = new EventEmitter<Font>();

  constructor(private resolver: ComponentFactoryResolver, private el: ElementRef, private vc: ViewContainerRef) {}

  ngOnInit() {
    let fontPicker = this.fontPicker;

    if (!this.fontPicker) {
      this.fontPicker = this.fpFallbackFont;
    }

    if (fontPicker != this.fontPicker) {
      this.fontPickerChange.emit(this.fontPicker);
    }
  }

  onClick() {
    if (!this.dialog) {
      const compFactory = this.resolver.resolveComponentFactory(FontPickerComponent);
      const injector = ReflectiveInjector.fromResolvedProviders([], this.vc.parentInjector);

      this.dialog = this.vc.createComponent(compFactory, 0, injector, []).instance;

      this.dialog.setDialog(this, this.el, this.fontPicker, this.fpPosition, this.fpPositionOffset,
        this.fpPositionRelativeToArrow, this.fpPresetLabel, this.fpPresetFonts, this.fpUploadButton,
        this.fpUploadButtonClass, this.fpUploadButtonText, this.fpStyleSelect, this.fpSizeSelect,
        this.fpCancelButton, this.fpCancelButtonClass, this.fpCancelButtonText, this.fpHeight, this.fpWidth);
    } else if (!this.dialog.open) {
      this.dialog.updateDialog(this.fontPicker, this.fpPosition, this.fpPositionOffset,
        this.fpPositionRelativeToArrow, this.fpPresetLabel, this.fpPresetFonts, this.fpUploadButton,
        this.fpUploadButtonClass, this.fpUploadButtonText, this.fpStyleSelect, this.fpSizeSelect,
        this.fpCancelButton, this.fpCancelButtonClass, this.fpCancelButtonText, this.fpHeight, this.fpWidth);

      this.dialog.openFontPicker();
    } else {
      this.dialog.closeFontPicker();
    }
  }

  fontChanged(value: Font) {
    this.fontPickerChange.emit(value)
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[fontPicker]',
  host: {
    '(click)': 'onClick()'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ComponentFactoryResolver, },
{type: ElementRef, },
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fontPicker': [{ type: Input, args: ['fontPicker', ] },],
'fpWidth': [{ type: Input, args: ['fpWidth', ] },],
'fpHeight': [{ type: Input, args: ['fpHeight', ] },],
'fpFallbackFont': [{ type: Input, args: ['fpFallbackFont', ] },],
'fpPresetLabel': [{ type: Input, args: ['fpPresetLabel', ] },],
'fpPresetFonts': [{ type: Input, args: ['fpPresetFonts', ] },],
'fpSizeSelect': [{ type: Input, args: ['fpSizeSelect', ] },],
'fpStyleSelect': [{ type: Input, args: ['fpStyleSelect', ] },],
'fpPosition': [{ type: Input, args: ['fpPosition', ] },],
'fpPositionOffset': [{ type: Input, args: ['fpPositionOffset', ] },],
'fpPositionRelativeToArrow': [{ type: Input, args: ['fpPositionRelativeToArrow', ] },],
'fpCancelButton': [{ type: Input, args: ['fpCancelButton', ] },],
'fpCancelButtonText': [{ type: Input, args: ['fpCancelButtonText', ] },],
'fpCancelButtonClass': [{ type: Input, args: ['fpCancelButtonClass', ] },],
'fpUploadButton': [{ type: Input, args: ['fpUploadButton', ] },],
'fpUploadButtonText': [{ type: Input, args: ['fpUploadButtonText', ] },],
'fpUploadButtonClass': [{ type: Input, args: ['fpUploadButtonClass', ] },],
'fontPickerChange': [{ type: Output, args: ['fontPickerChange', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
